define('OutSystems/ReactView/Main',["require", "exports", "@outsystems/virtualized-list", "OutSystems/ClientRuntime/VersionDefinition", "./AnimatedGroup", "./BaseView", "./FeedbackMessage", "./HtmlTags", "./Portal", "./RouteComponents", "./Router", "./ScrollExtensions", "./Widget"], function (require, exports, VirtualizedScrollViewerModule, VersionDefinition, AnimatedGroupModule, BaseViewModule, FeedbackMessageModule, HtmlTagsModule, PortalModule, RouteComponentsModule, RouterModule, ScrollExtensionsModule, WidgetModule) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Version = exports.HtmlTags = exports.VirtualizedScrollViewer = exports.Portal = exports.AnimatedGroup = exports.RouteComponents = exports.FeedbackMessage = exports.Widget = exports.Router = exports.ScrollExtensions = exports.BaseView = void 0;
    exports.BaseView = BaseViewModule;
    exports.ScrollExtensions = ScrollExtensionsModule;
    exports.Router = RouterModule;
    exports.Widget = WidgetModule;
    exports.FeedbackMessage = FeedbackMessageModule;
    exports.RouteComponents = RouteComponentsModule;
    exports.AnimatedGroup = AnimatedGroupModule;
    exports.Portal = PortalModule;
    exports.VirtualizedScrollViewer = VirtualizedScrollViewerModule;
    exports.HtmlTags = HtmlTagsModule;
    exports.Version = "3.23.0";
    VersionDefinition.registerPackage("client-runtime-view-framework-react", exports.Version);
});
//# sourceMappingURL=Main.js.map;
